import React from "react";
import Project from "./projetEtp";

export function ProjectFenced() {
  return <Project status="Cloturé" />;
}